module.exports = __webpack_public_path__ + "static/4-e129bfffd665e0347c6b2d338311c574.jpg";